interface SettingsKpiCardProps {
  label: string;
  value: string;
  icon: string;
  color: "primary" | "accent" | "warning" | "danger" | "secondary" | "caution";
  subtitle?: string;
}

const colorMap = {
  primary: { bg: "bg-primary-50", iconBg: "bg-primary-100", iconColor: "text-primary-600", text: "text-primary-900" },
  accent: { bg: "bg-accent-50", iconBg: "bg-accent-100", iconColor: "text-accent-600", text: "text-accent-900" },
  warning: { bg: "bg-warning-50", iconBg: "bg-warning-100", iconColor: "text-warning-600", text: "text-warning-900" },
  danger: { bg: "bg-danger-50", iconBg: "bg-danger-100", iconColor: "text-danger-600", text: "text-danger-900" },
  secondary: { bg: "bg-secondary-50", iconBg: "bg-secondary-100", iconColor: "text-secondary-600", text: "text-secondary-900" },
  caution: { bg: "bg-caution-50", iconBg: "bg-caution-100", iconColor: "text-caution-600", text: "text-caution-900" },
};

export default function SettingsKpiCard({ label, value, icon, color, subtitle }: SettingsKpiCardProps) {
  const c = colorMap[color];
  return (
    <div className={`${c.bg} rounded-xl p-4 border border-background-200/70 transition-colors hover:border-background-300/60`}>
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-foreground-500">{label}</span>
        <div className={`w-8 h-8 rounded-lg ${c.iconBg} flex items-center justify-center`}>
          <i className={`${icon} ${c.iconColor} text-base`} />
        </div>
      </div>
      <div className={`text-xl md:text-2xl font-bold ${c.text} font-heading`}>{value}</div>
      {subtitle && <div className="text-xs text-foreground-400 mt-1">{subtitle}</div>}
    </div>
  );
}